"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealPetAbilityHandler = exports.HealPetActorAbilityFactory = exports.HealPetAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class HealPetAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.HealPet;
        this.__typeName = "HealPet";
    }
}
exports.HealPetAbilityArgs = HealPetAbilityArgs;
let HealPetActorAbilityFactory = class HealPetActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("HealPet", "OneCompanion", 3);
    }
};
HealPetActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("HealPet")
], HealPetActorAbilityFactory);
exports.HealPetActorAbilityFactory = HealPetActorAbilityFactory;
let HealPetAbilityHandler = class HealPetAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [petId] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated(sequence) {
                container.applyHealing({
                    sequence,
                    healerId: ability.invokerId,
                    targetId: petId,
                    amount: container.getPercentOfBaseHealth(petId, 50),
                    onApplied: sequence => sequence.pushSequence("sequential")
                        .push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(petId, "feet"), "GreenEnergyCircle"))
                });
            },
        });
    }
};
HealPetAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.HealPet)
], HealPetAbilityHandler);
exports.HealPetAbilityHandler = HealPetAbilityHandler;
